import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Send the httpOnly auth cookie with every request.
axios.defaults.withCredentials = true;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session from the httpOnly cookie via /auth/me.
  useEffect(() => {
    axios
      .get(`${API}/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (payload) => {
    const res = await axios.post(`${API}/auth/register`, payload);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    setUser(null);
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (e) {
      console.warn('[Auth] logout failed', e);
    }
  };

  const updateProfile = async (updates) => {
    const res = await axios.patch(`${API}/auth/me`, updates);
    setUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}
